import NewItemIssue from "../../../../components/@documents/item_issues/NewItemIssue";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemIssueNewPage() {

    return (
        <NewItemIssue 
            routeType={routeTypes.admin}
        />
    )
}